import React, { FC, useState } from 'react';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import TableItem from '../TableItem';
import useModalFlag from '../../../../hooks/useModalFlag';
import { FlyingTableHeader } from './components/FlyingTableHeader';

import styles from './styles/index.module.scss';


export const Schedule: FC = () => {
  const [, setOrderInfo] = useState<Record<string, any> | null>({});
  const { setModalFlag: toggleFlagModalOrder } = useModalFlag();
  
  const {
    flyingList,
  } = useStoreon<State, Events>('flyingList');
  const handleClickModal = (date: string | null, order: Record<string, any> | null) => {
    setOrderInfo({ date, order });
    toggleFlagModalOrder();
  };


  return (
    <>
      <div className={styles.wrapper}>
        <table className={styles.table}>
            <FlyingTableHeader />
          <tbody>
            {flyingList && flyingList.map((element) => (
              <TableItem
                key={element.id}
                {...element}
                handleClickModal={handleClickModal}
              />
            ))}
          </tbody>
        </table>
       
      </div>
    </>
  );
};
